import { apiRequest } from "./client";
import type {
  BulkQueueActionResult,
  BulkQueuePage,
  BulkQueueQuery,
  FundingOutcome,
  PayInRequest,
} from "@kkp/api-client";

export type {
  BulkQueueActionResult,
  BulkQueueItem,
  FundingOutcome,
  PayInRequest,
} from "@kkp/api-client";

export async function confirmPayIn(
  request: PayInRequest,
): Promise<FundingOutcome> {
  return apiRequest<FundingOutcome>({
    path: "/payin",
    method: "POST",
    body: request,
  });
}

export async function rerouteFromAnomaly(
  request: PayInRequest,
): Promise<FundingOutcome> {
  return apiRequest<FundingOutcome>({
    path: "/reroute",
    method: "POST",
    body: request,
  });
}

export async function listBulkQueue(
  params: BulkQueueQuery,
): Promise<BulkQueuePage> {
  const search = new URLSearchParams();
  if (params.cursor) search.set("cursor", params.cursor);
  if (params.limit) search.set("limit", String(params.limit));

  return apiRequest<BulkQueuePage>({
    path: `/bulk-queue${search.toString() ? `?${search.toString()}` : ""}`,
    method: "GET",
  });
}

export async function executeBulkQueue(
  seqId: string,
): Promise<BulkQueueActionResult> {
  return apiRequest<BulkQueueActionResult>({
    path: `/bulk-queue/${seqId}/execute`,
    method: "POST",
    body: {},
  });
}

export async function failBulkQueue(
  seqId: string,
): Promise<BulkQueueActionResult> {
  return apiRequest<BulkQueueActionResult>({
    path: `/bulk-queue/${seqId}/fail`,
    method: "POST",
    body: {},
  });
}

export async function failRandomBulkQueue(
  seqId: string,
): Promise<BulkQueueActionResult> {
  return apiRequest<BulkQueueActionResult>({
    path: `/bulk-queue/${seqId}/fail-random`,
    method: "POST",
    body: {},
  });
}
